import axios from 'axios';

const axiosIPFSInstance = axios.create({
  baseURL: 'https://dw4trust-testnet-ipfs-6d70.gke-europe.settlemint.com/sm_pat_d38de02e6f795d6f/gateway/ipfs',  // URL du proxy PHP
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': '6e552fb153cf4fd693aec72a755276ce',
  }
});

export default axiosIPFSInstance;